/* eslint-disable */
<template>
  <div>
    <vs-breadcrumb>
      <li>
           <router-link :to="'dashboardTemp'" title="Device">Dashboard</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Sensor List</li>
    </vs-breadcrumb>
    <vs-card style="border-radius: 20px">
      <div class="mt-2">
        <vs-row id="center">
          <h3 class="headerText">Sensor List</h3>
          <vs-spacer />
          <vs-input class="mr-2" placeholder="Search" v-model="value1" />
          <vs-dropdown vs-trigger-click>
            <vs-icon
              icon="settings"
              class="cursor-pointer"
              size="20px"
              color="dark"
            ></vs-icon>

            <vs-dropdown-menu style="width: 20%">
              <vs-row
                :disabled="visibleFields.length == 1 && field.visible"
                v-for="field in fields"
                :key="field.key"
                class="mt-2"
                vs-w="12"
              >
                <vs-checkbox v-model="field.visible" class="col-checkbox">
                  {{ field.label }}</vs-checkbox
                >
              </vs-row>
            </vs-dropdown-menu>
          </vs-dropdown> </vs-row
        ><br />
        <b-table
          :filter-included-fields="['id']"
          head-variant="light"
          style="white-space: nowrap; font-size: 0.813rem; text-align: center"
          :items="filteredList"
          responsive
          :fields="visibleFields"
        >
          <!-- A virtual composite column -->
          <template #cell(date)="data">
            {{ $moment(data.item.date).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
          <template #cell(id)="data"> Sensor No. {{ data.item.id}} </template>

          <template #cell(temperature)="data">
            {{ data.item.temperature }} °C
          </template>
        </b-table>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "Sensor",

  data: () => ({
    deviceList: [],
    value1: "",
    fields: [
      { key: "date", label: "Timestamp", visible: true, sortable: true },
      { key: "id", label: "Device No.", visible: true, sortable: true },
      {
        key: "temperature",
        label: "Temperature (°C)",
        visible: true,
        sortable: true,
      },
      { key: "humidity", label: "Humidity", visible: true, sortable: true },
      { key: "location", label: "Location", visible: true, sortable: true },
      { key: "height", label: "Hight", visible: true, sortable: true },
      { key: "color", label: "Battery", visible: true, sortable: true },
    ],
  }),
  components: {},
  methods: {},
  mounted() {
    this.deviceList = this.$session.get("deviceList");
  },
  computed: {
    filteredList() {
      return this.deviceList.filter((post) => {
        return (
          post.temperature
            .toString()
            .toLowerCase()
            .includes(this.value1.toLowerCase()) ||
          post.location
            .toString()
            .toLowerCase()
            .includes(this.value1.toLowerCase()) ||
        post.id
            .toString()
            .toLowerCase()
            .includes(this.value1.toLowerCase()) ||
          post.humidity
            .toString()
            .toLowerCase()
            .includes(this.value1) || 
            post.date
            .toString()
            .toLowerCase()
            .includes(this.value1.toLowerCase())
        );
      });
    },
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
  },
};
</script>
<style scoped>
#btns {
  cursor: pointer;
}
#center {
  display: flex;
  align-items: center;
}
.w3-disabled *,
:disabled * {
  color: black;
}
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#v {
  display: none;
}

#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}

@media screen and (max-width: 600px) {
  #v {
    display: inline;
    padding: 0px;
    right: -20px;
  }
  #p {
    display: none;
  }
  .a {
    /* background: pink; */
    width: 200px;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>